import * as React from 'react'

import '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  field: Field
  selectedEmployeeIds: number[]
  label: string
  secondaryLabel?: React.ComponentProps<typeof Text>['secondaryLabel']
  isMultiSelect: boolean
  onBlur: React.ComponentProps<typeof Text>['onBlur']
  onFocus: React.ComponentProps<typeof Text>['onFocus']
  mandatory?: boolean
  employees: Employee[]
}

const EmployeeTextField: React.FC<Props> = ({
  field,
  selectedEmployeeIds,
  label,
  secondaryLabel,
  isMultiSelect,
  onFocus,
  onBlur,
  mandatory,
  employees,
}) => {
  const getEmployeeFullName = (): string | null | undefined => {
    if (!field.value) return null

    const employee = employees.find((employee) => employee.attributes.id === parseInt(field.value))

    if (!employee) return null

    return employeeUser(employee).fullName()
  }

  const getMultiSelectText = (): string => {
    const noUsersSelected = i18n.t('common.select')
    const employeeFullName = getEmployeeFullName()

    if (employeeFullName === null) return noUsersSelected

    const usersSelected = i18n.tp('user_selector.label', {
      count: selectedEmployeeIds.length,
      user: employeeFullName,
    })

    return selectedEmployeeIds.length ? usersSelected : noUsersSelected
  }

  const getSingleSelectText = (): string => {
    const noUsersSelected = i18n.t('common.select')
    const employeeFullName = getEmployeeFullName()

    if (employeeFullName === null) return noUsersSelected

    const user = i18n.tp('user_selector.label', {
      count: 1,
      user: employeeFullName,
    })

    return field.value === null || field.value === '' ? noUsersSelected : user
  }

  return (
    <Text
      label={label}
      field={field}
      onFocus={onFocus}
      onBlur={onBlur}
      value={!isMultiSelect ? getSingleSelectText() : getMultiSelectText()}
      secondaryLabel={secondaryLabel}
      select
      mandatory={mandatory}
    />
  )
}

export default EmployeeTextField
